import { useEffect } from 'react'
import { useStore } from '@/store'
import { useHasPermission } from '@/auth/hooks'

/**
 * Fleet sidebar page is deprecated — load control lives in the topbar Load panel.
 * Keep this route so deep links / bookmarks open the panel and bounce to world.
 */
export default function FleetView() {
  const setView = useStore((s) => s.setView)
  const setOverlayPanel = useStore((s) => s.setOverlayPanel)
  const canFleet = useHasPermission('fleet:control')
  const canManage = useHasPermission('user:manage')

  useEffect(() => {
    if (canFleet || canManage) setOverlayPanel('amplify')
    setView('world')
  }, [canFleet, canManage, setOverlayPanel, setView])

  return (
    <div style={{ padding: 24, color: 'var(--t-2)', fontSize: 13 }}>
      Fleet control moved to the <strong style={{ color: 'var(--t-0)' }}>Load</strong> chip in the
      top bar.
    </div>
  )
}
